var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictureUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 113.65 84",
    style: {
      enableBackground: "new 0 0 113.65 84"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#0396FD;}\r\n\t.st1{fill:#0077F0;}\r\n\t.st2{fill:#C9F0FF;}\r\n\t.st3{fill:#9AE7FD;}\r\n\t.st4{fill:#80E0DC;}\r\n\t.st5{fill:#00A8B0;}\r\n\t.st6{fill:#FFD86E;}\r\n\t.st7{fill:#FFB509;}\r\n\t.st8{fill:#00BDB4;stroke:#FFFFFF;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st9{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M78.12,80.6H9.47c-3.07,0-5.56-2.49-5.56-5.56V19.19c0-3.07,2.49-5.56,5.56-5.56h68.65 c3.07,0,5.56,2.49,5.56,5.56v55.85C83.68,78.11,81.19,80.6,78.12,80.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M83.68,19.19v55.85c0,3.07-2.49,5.56-5.56,5.56h-5.5c3.07,0,5.56-2.49,5.56-5.56V19.19 c0-3.07-2.49-5.56-5.56-5.56h5.5C81.19,13.63,83.68,16.12,83.68,19.19z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M88.04,70.28H19.39c-3.07,0-5.56-2.49-5.56-5.56V8.87c0-3.07,2.49-5.56,5.56-5.56h68.65 c3.07,0,5.56,2.49,5.56,5.56v55.85C93.6,67.79,91.11,70.28,88.04,70.28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M93.6,8.87v55.85c0,3.07-2.49,5.56-5.56,5.56h-5.5c3.07,0,5.56-2.49,5.56-5.56V8.87 c0-3.07-2.49-5.56-5.56-5.56h5.5C91.11,3.31,93.6,5.8,93.6,8.87z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M93.6,56.41L73.15,33.36c-0.35-0.39-0.95-0.41-1.32-0.04L59.61,45.54L43.83,27.77 c-0.35-0.39-0.95-0.41-1.32-0.04L13.83,56.41v8.32c0,3.07,2.49,5.56,5.56,5.56h68.65c3.07,0,5.56-2.49,5.56-5.56V56.41z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M93.6,56.41v8.32c0,3.07-2.49,5.56-5.56,5.56h-5.5c3.07,0,5.56-2.49,5.56-5.56V50.21L93.6,56.41z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M85.42,20.15c0,4.4-3.56,7.96-7.96,7.96s-7.96-3.56-7.96-7.96s3.56-7.96,7.96-7.96S85.42,15.75,85.42,20.15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M85.42,20.15c0,4.4-3.56,7.96-7.96,7.96c-2.23,0-4.25-0.92-5.7-2.4c0.93,0.38,1.96,0.6,3.03,0.6 c4.4,0,7.96-3.56,7.96-7.96c0-2.16-0.86-4.12-2.26-5.56C83.38,13.98,85.42,16.83,85.42,20.15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.46,10.83c-5.14,0-9.32,4.18-9.32,9.32s4.18,9.32,9.32,9.32c5.14,0,9.32-4.18,9.32-9.32S82.6,10.83,77.46,10.83z  M77.46,26.75c-3.64,0-6.6-2.96-6.6-6.6s2.96-6.6,6.6-6.6c3.64,0,6.6,2.96,6.6,6.6S81.1,26.75,77.46,26.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.04,1.96H19.39c-3.81,0-6.91,3.1-6.91,6.91v3.4H9.47c-3.81,0-6.92,3.1-6.92,6.92v55.85c0,3.81,3.1,6.92,6.92,6.92H54.9 c0.75,0,1.36-0.61,1.36-1.36c0-0.75-0.61-1.36-1.36-1.36H9.47c-2.32,0-4.2-1.89-4.2-4.2V19.19c0-2.32,1.89-4.2,4.2-4.2h3.01v49.74 c0,3.81,3.1,6.91,6.91,6.91h62.93v3.4c0,2.32-1.89,4.2-4.2,4.2H63.49c-0.75,0-1.36,0.61-1.36,1.36c0,0.75,0.61,1.36,1.36,1.36 h14.63c3.81,0,6.91-3.1,6.91-6.92v-3.4h3.01c3.81,0,6.92-3.1,6.92-6.91V8.87C94.95,5.06,91.85,1.96,88.04,1.96z M92.24,52.84 L74.16,32.46c-0.41-0.46-1-0.74-1.62-0.76c-0.62-0.02-1.23,0.22-1.67,0.66l-11.21,11.2l-14.82-16.7c-0.41-0.46-1-0.74-1.62-0.76 c-0.63-0.02-1.23,0.22-1.67,0.66l-10.51,10.5c-0.53,0.53-0.53,1.39,0,1.92c0.53,0.53,1.39,0.53,1.92,0l10.17-10.16l19.26,21.7 c0.27,0.3,0.64,0.46,1.02,0.46c0.32,0,0.64-0.11,0.9-0.34c0.56-0.5,0.61-1.35,0.11-1.91l-2.96-3.33l10.98-10.98l19.79,22.3v7.8 c0,2.32-1.89,4.2-4.2,4.2H19.39c-2.32,0-4.2-1.89-4.2-4.2v-7.75l11.93-11.92c0.53-0.53,0.53-1.39,0-1.92 c-0.53-0.53-1.39-0.53-1.92,0l-10.01,10V8.87c0-2.32,1.89-4.2,4.2-4.2h68.65c2.32,0,4.2,1.89,4.2,4.2V52.84z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 93.6,
    cy: 64.54,
    r: 17.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 92.74,
    y: 56.54,
    className: "st9",
    width: 1.71,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.74,
    y: 56.54,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 158.1398 -29.0512)",
    className: "st9",
    width: 1.71,
    height: 16
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictureUpload);
export default __webpack_public_path__ + "static/media/picture-upload.f07eb075721af428eab72dece0d16aab.svg";
export { ForwardRef as ReactComponent };